<template>
  <div>
    <v-col v-if="searchBox" cols="12" id="searchBoxDiv">
      <SearchBox
        id="searchBox"
        @search="search = $event"
      />
    </v-col>
    <ListThreeLItemsSelect
      :items="computedProdutos"
      itemTitle="descricao"
      itemSubtitle="preco_bruto"
      :isSubtitlePrice="true"
      itemText="qt_estoque"
      :fullscreen="true"
      :searchBox="searchBox"
      @clicked="$emit('produtoSelected', $event)"
    />
    <div class="my-3" id="listProdutosPagination">
      <v-pagination
        v-model="page"
        :length="totalPages"
        circle
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SearchBox from '@/components/shared/SearchBox';
import ListThreeLItemsSelect from '@/components/shared/list/ListThreeLItemsSelect';
import { convertStringToCompare } from '@/helpers';

export default {
  name: 'ListProdutosSelect',
  props: {
    searchBox: {
      type: Boolean,
      default: false
    },
    tabelaPreco: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    page: 1,
    order: 'descricao',
    search: '',
  }),
  components: {
    SearchBox,
    ListThreeLItemsSelect
  },
  watch: {
    searchBox(value) {
      if (value) this.$nextTick(() => document.getElementById('searchBox').focus());
      else this.search = '';
    }
  },
  computed: {
    ...mapGetters(['produtos']),
    computedProdutos() {
      const start = (this.page - 1) * 10;
      const end = start + 10;
      let searchTerm = this.search || '';
      searchTerm = convertStringToCompare(searchTerm);
      return this.retornaProdutosAtualizadosPrecoTabelaPreco()
        .filter(produto =>
          Object.keys(produto)
            .some(key => convertStringToCompare(produto[key]).includes(searchTerm || ''))
        )
        .slice(start, end)
        .sort((a, b) => a[this.order] > b[this.order] ? 1 : -1);
    },
    totalPages() {
      const total = this.produtos.length / 10;
      return total !== Infinity ? Math.ceil(total) : 0;
    }
  },
  methods: {
    retornaProdutosAtualizadosPrecoTabelaPreco() {
      if (!this.tabelaPreco) return this.produtos;

      const mProdutos = JSON.parse(JSON.stringify(this.produtos));

      mProdutos.forEach(produto => {
        const itemTabelaPreco = this.tabelaPreco.itens.find(
          itemTabelaPreco => itemTabelaPreco.id_produto === produto.id_produto && itemTabelaPreco.id_unidade === produto.id_unidade
        );

        if (itemTabelaPreco) {
          produto.preco_bruto = itemTabelaPreco.preco_venda;
        }
      });

      return mProdutos;
    },
  }
}
</script>

<style>

</style>